<section>
  <div class="border_container">
    <div class="col container-style p-2">
      <div class="col py-1 px-2 mb-2" *ngIf="providerInvoiceModel.state == 1">
        <form [formGroup]="formProviderInvoiceRetention">
          <div class="row">
            <div class="col field-tax">
              <app-custom-autocomplete formControlName="taxId" [labelText]="'Impuesto'" [required]="true"
                [list]="listTaxes" (onChangeSelect)="changeTax($event)"> </app-custom-autocomplete>
            </div>
            <div class="col field-type-tax">
              <app-custom-input-text [value]="taxType" [labelText]="'Tipo'" [disabled]="true"></app-custom-input-text>
            </div>
            <div class="col field-base-value">
              <app-custom-input-decimal formControlName="baseValue" [labelText]="'Base'" [required]="true"
                (onChangeNumber)="changeBaseValue($event)"></app-custom-input-decimal>
            </div>
            <div class="col field-tax-rate">
              <app-custom-input-decimal formControlName="taxRate" [labelText]="'%'"></app-custom-input-decimal>
            </div>
            <div class="col field-total-value">
              <app-custom-input-decimal [value]="totalValue" [labelText]="'Valor'"
                [disabled]="true"></app-custom-input-decimal>
            </div>
            <div class="col field-buttons d-flex align-items-end gap-2 mt-2">
              <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disabledActions" (onClick)="send()"></app-custom-button>
              <app-custom-button [title]="'Limpiar'" [icon]="'pi pi-eraser'" [severity]="'contrast'"
                [disabled]="disabledActions" (onClick)="cancel()"></app-custom-button>
            </div>
          </div>
        </form>
      </div>
      <div class="col">
        <app-custom-table [headers]="header" [data]="data" [actions]="tableActions" [showCheckbox]="!disabledActions"
          [checkBoxAction]="checkboxActions" [clearSelectionTrigger]="clearSelectionTrigger"
          (onPageChange)="onPageChange($event)" (onAction)="onAction($event)"
          (onRecoverData)="getProviderInvoiceRetentionsByProviderInvoiceIdWithPagination()">
        </app-custom-table>
      </div>
    </div>
    <div class="col d-flex justify-content-end mt-3">
      <app-custom-button [label]="'Salir'" [severity]="'danger'" [variant]="undefined"
        (onClick)="close()"></app-custom-button>
    </div>
  </div>
</section>